import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from './LayoutComponents';

import { absolutePositionFillStyle } from './LayoutStyles';

// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
// and overrides from reactDataGrid.styl
export const ExplorerStyledDataGridContainer = divWithStyle('dataGridContainer', {
  flex: 1,
  color: TabStyles.Typography.Color.Primary,
  fontSize: '14px', // This size is not in TabStyles
  $nest: {
    '.tb-react-dg-hrow': {
      border: 'none'
    },
    '.tb-react-dg-hcell-resizable': {
      border: 'none'
    },
    '.tb-react-dg-hcol': {
      border: 'none !important'
    },
    '.tb-react-dg-body': {
      borderTop: `1px solid ${TabStyles.Colors.F3}`
    },
    '.tb-react-dg-bcell': {
      pointerEvents: 'none',
      paddingLeft: 0,
      paddingRight: 0,
      $nest: {
        '&:focus': {
          outline: 'none',
        },
        '> div': {
          pointerEvents: 'all',
        },
      },
    },
  },
});

export const DataGridSpinnerGlass = divWithStyle('DataGridSpinnerGlass', {
  ...absolutePositionFillStyle,
  background: 'rgba(255,255,255,.6)',
});
